export default {
  LOAD_STUDY_PLAN_OVERVIEW_PAGE_START: 'LoadStudyPlanOverviewPageStart',
  LOAD_STUDY_PLAN_OVERVIEW_PAGE_END: 'LoadStudyPlanOverviewPageEnd',
  APPROVE_STUDY_PLAN_START: 'ApproveStudyPlanStart',
  APPROVE_STUDY_PLAN_END: 'ApproveStudyPlanEnd',
  DELETE_STUDY_PLAN_START: 'DeleteStudyPlanStart',
  DELETE_STUDY_PLAN_END: 'DeleteStudyPlanEnd',
  TOGGLE_CONFIRM_DIALOG: 'ToggleConfirmDialog'
};